// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Scene_6_wrapper__1wFe8"};